import { BIGQUERY_GROUP } from '../../constants';
import { EXPERIMENTS } from '../../utils/experiments';

/**
 * Type name of the BigQuery event.
 */
export const BIGQUERY_TYPE = 'clicked_header.registration.button_click_header';

/**
 * BigQuery event to send on click.
 */
export const BIGQUERY_EVENT = {
    type: BIGQUERY_TYPE,
    group: BIGQUERY_GROUP,
};

export const EXPERIMENT_STATE = {
    ACTIVE: 'active',
    LOCKED: 'locked',
    DISABLED: 'disabled',
} as const;

export const ONBOARDING_EXPERIMENT_ID = EXPERIMENTS.LYNXES_SEAMLESS_ONBOARDING_AND_ROUTING;
